// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../action-creators/busy-counter';
import {getFile, getFileRga, getFileTemplateRgaMassUpload} from '../repositories';
import {getStore} from '../../store-factory';
import {openFile} from './open-file';

export const downloadFile = async file => {

    const dispatch = getStore().dispatch;

    dispatch(busyCounter.increaseBusyCounter());
    try {

        const response = await getFile(file);

        const fileName = decodeURI(file.fileName);

        const blob = await response.blob();

        openFile(blob, fileName, 'application/octet-stream');

    } catch (error) {

    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

};

export const downloadFileRga = async file => {

    const dispatch = getStore().dispatch;

    dispatch(busyCounter.increaseBusyCounter());
    try {

        const response = await getFileRga(file);

        const fileName = decodeURI(file.fileName);

        const blob = await response.blob();

        openFile(blob, fileName, 'application/octet-stream');

    } catch (error) {

    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

};

export const downloadRgaTemplate = async () => {

    const dispatch = getStore().dispatch;

    dispatch(busyCounter.increaseBusyCounter());
    try {

        const response = await getFileTemplateRgaMassUpload();

       // const fileName = 'RGA Upload Templet_Part Request(FY25)';

        const blob = await response.blob();

        openFile(blob, 'RGA_Upload_Template_Part_Request(FY25).xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

    } catch (error) {

    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

};



// WEBPACK FOOTER //
// ./src/shared/services/file-download.js